import React, { useCallback, useEffect, useState } from "react";
import styled from "styled-components";

import UserCode from "./UserCode";
import Summary from "./Summary";
import Rewards from "./Rewards.tsx";
// import Records from "./Records.tsx";
import { motion } from "framer-motion";
import useReferralCode from "../../hooks/useReferralCode";
import { getGinzaRewardRecords } from "../../utils/api/ginzaApi";
import { useWeb3React } from "@web3-react/core";
import { CHAIN_IDS_TO_NAMES } from "../../utils/constant/chains";
import { getRewardClaimStatus } from "../../utils/api/referralApi";

export type RewardProps = {
  ID: number;
  MerkleProof: string[];
  Discount: number;
  Rebate: number;
  RewardSession: {
    WeekNumber: number;
    RewardToken: string;
    RewardTokenDecimal: number;
  };
  isClaimed: boolean;
};

const ReferralPage: React.FC = () => {
  const { account, chainId, library } = useWeb3React();
  const { referralCode, updateReferralCode, referreeCount } = useReferralCode();

  const [rewards, setRewards] = useState<RewardProps[]>([]);

  const updateRewardRecords = useCallback(async () => {
    if (account && chainId) {
      const _rewards = await getGinzaRewardRecords(
        account,
        CHAIN_IDS_TO_NAMES[chainId].toLowerCase()
      );
      const rewardsWthClaimStatus = await Promise.all(
        _rewards.map(async (r: RewardProps) => {
          const weeNum = r.RewardSession.WeekNumber;
          let status = false;
          try {
            status = await getRewardClaimStatus(
              account,
              chainId,
              library,
              weeNum
            );
          } catch (e) {}
          return { ...r, isClaimed: status };
        })
      );
      setRewards(rewardsWthClaimStatus);
    }
  }, [account, chainId, library]);

  useEffect(() => {
    updateRewardRecords();
  }, [updateRewardRecords]);

  return (
    <Container
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <UserCode
        referralCode={referralCode}
        updateReferralCode={updateReferralCode}
      />
      <Summary referreeCount={referreeCount} lastWeekReward={rewards[0]} />
      <Rewards rewards={rewards} updateRewardRecords={updateRewardRecords} />
      {/* <Records /> */}
    </Container>
  );
};

export default ReferralPage;

const Container = styled(motion.div)`
  padding: 24px 24px 48px 24px;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
`;
